import { Button, Form, Input, Select, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import GetClientType from './GetClientType';
import { useGetClientUidQuery } from '../../store/ReactWebSiteApi';

function ClientQuery(props) {
    const [form] = Form.useForm();
    const {data:dataUid,isSuccess:isSuccessUid} = useGetClientUidQuery({ec_e_id:localStorage.getItem("e_id")})
    const [handler,setHandler] = useState()
    useEffect(() => {
        if(isSuccessUid){
            if(dataUid.Status==='success'){
                const arr = dataUid.Result.map((item) => {
                    const {ec_uid,ec_uname} = item;
                    return item = {value:ec_uid,label:ec_uname}
                })
                setHandler(arr)
            }
        }
    },[dataUid,isSuccessUid])
    return (
        <Form
            form={form}
            layout="inline"
            name="form_in_modal"
            initialValues={{
                modifier: 'public',
                ec_type_id:'',
                ec_name:'',
                ec_content:'',
                ec_uid:'',
            }}
            labelCol={{ span: 7 }}
            onFinish={() => {
                form
                .validateFields()
                .then((values) => {
                    props.getClientQuery(values);
                })
                .catch((info) => {
                    console.log('Validate Failed:', info);
                });
            }}
        >
            <GetClientType 
                name="ec_type_id" 
                label='客户类型' 
                getClientType={(e) => {}}
                style={{width:"200px"}}
            />
            <Form.Item label='客户名称' wrapperCol={{span:15}} name='ec_name'>
                <Input 
                    onChange={(e) => {}}
                />
            </Form.Item>                                                   
            <Form.Item name="ec_content" label='备注' wrapperCol={{span:15}}>
                <Input
                    
                    onChange={(e) => {                       
                    }}
                />
            </Form.Item>
            <Form.Item name='ec_uid' label='操作员' wrapperCol={{span:15}}>
                <Select 
                    options={handler} 
                    onChange={(e) => {}}
                    style={{width:"200px"}}
                />
            </Form.Item>  
            <Form.Item wrapperCol={{offset:"6"}}>
                <Space>
                    <Button
                        htmlType='submit'
                    >
                        查询
                    </Button>
                    <Button onClick={() => {                                        
                        form.resetFields();
                        props.getClientQuery({
                            ec_action:'search',
                            ec_type_id:'',
                            ec_name:'',
                            ec_content:'',
                            ec_uid:'',
                            ec_mode:'',
                            ec_state:'2',
                        })
                        }}>重置</Button>
                </Space>
            </Form.Item>                                
        </Form>
    )
}

export default ClientQuery